























import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CourseCard extends Vue {
  @Prop() id!: string;
  @Prop() img!: string;
  @Prop() code!: string;
  @Prop() color!: string;
  @Prop() name!: string;
  @Prop() urlCode!: string;

  get imgUrl() {
    return this.img === ""
      ? require("@/assets/img/course-preview-default.jpg")
      : this.img;
  }
}
